export * from "./path";
export * from "./zIndex";
export * from "./types";
export {default as config} from "./config";

export const TEMP_TOKEN_TIME = 10;
export const ACCESS_EXPIRE_TIME = 60;
export const REFRESH_EXPIRE_TIME = 480;

// 자동 로그아웃 설정
export const INACTIVITY_TIMEOUT = 30; // 자동 로그아웃 (분)
export const INACTIVITY_WARNING = INACTIVITY_TIMEOUT - 5; // 경고 팝업 (분) - 로그아웃 5분 전
export const ACTIVITY_CHECK_INTERVAL = 60000; // 체크 간격 (1분, ms)
export const LAST_ACTIVITY_KEY = "LAST_API_ACTIVITY";

export const SALES_MANAGEMENT_SAMPLE = {
	YEARLY: [
		{
			id: "Y001",
			period: "YEARLY",
			target: "DEPARTMENT",
			status: "APPROVED",
			manager: {
				id: "MGR100",
				name: "Alice Johnson"
			},
			details: [
				{
					id: "DET100",
					type: "YEARLY_ACTION_PLAN",
					content: "Company-wide strategy alignment and budget allocation."
				},
				{
					id: "DET101",
					type: "FIRST_HALF_ACTION_PLAN",
					content: "Focus on product launches and marketing campaigns."
				},
				{
					id: "DET102",
					type: "SECOND_HALF_ACTION_PLAN",
					content: "Expand customer outreach and review performance metrics."
				}
			],
			firstApprover: {
				id: "APR200",
				name: "Michael Lee"
			},
			firstApproverStatus: "APPROVED",
			firstApprovedAt: "2025-01-10T09:00:00.000Z",
			firstApproverComment: "Well-structured plan.",
			secondApprover: {
				id: "APR201",
				name: "Sophia Martinez"
			},
			secondApproverStatus: "APPROVED",
			secondApprovedAt: "2025-01-15T10:30:00.000Z",
			secondApproverComment: "Looks good to proceed."
		}
	],
	MONTHLY: [
		{
			id: "M001",
			period: "MONTHLY",
			target: "SALES_DEPARTMENT_ALL",
			status: "APPROVAL_PENDING",
			manager: {
				id: "MGR200",
				name: "David Wilson"
			},
			yearMonth: "2025-02",
			firstApprover: {
				id: "APR300",
				name: "Emma Davis"
			},
			firstApproverStatus: "PENDING",
			firstApprovedAt: null,
			firstApproverComment: "Awaiting review.",
			secondApprover: {
				id: "APR301",
				name: "James White"
			},
			secondApproverStatus: "DEFAULT",
			secondApprovedAt: null,
			secondApproverComment: "Pending first approval.",
			details: [
				{
					id: "DET200",
					type: "MONTHLY_ACTION_PLAN",
					content: "Increase customer engagement and boost sales numbers."
				}
			]
		}
	],
	WEEKLY: [
		{
			id: "98765",
			period: "WEEKLY",
			target: "PERSONAL",
			status: "REJECTED",
			department: "Marketing",
			manager: {
				id: "MGR004",
				name: "Olivia Brown"
			},
			fromDate: "2025-02-12",
			toDate: "2025-02-18",
			firstApprover: {
				id: "APR007",
				name: "William Harris"
			},
			firstApproverStatus: "REJECTED",
			firstApprovedAt: null,
			firstApproverComment: "Not sufficient details provided.",
			secondApprover: {
				id: "APR008",
				name: "Charlotte Thomas"
			},
			secondApproverStatus: "DEFAULT",
			secondApprovedAt: null,
			secondApproverComment: "Not yet reviewed.",
			details: [
				{
					id: "DET004",
					type: "THIS_WEEK_ACTION_PLAN",
					content: "Plan social media outreach and content calendar."
				},
				{
					id: "DET005",
					type: "LAST_WEEK_ACTION_REPORT",
					content: "Completed advertising campaign and analyzed engagement metrics."
				}
			]
		},
		{
			id: "98766",
			period: "WEEKLY",
			target: "DEPARTMENT",
			status: "APPROVAL_PENDING",
			department: "Sales",
			manager: {
				id: "MGR005",
				name: "Ethan Clark"
			},
			fromDate: "2025-02-05",
			toDate: "2025-02-11",
			firstApprover: {
				id: "APR009",
				name: "Isabella Moore"
			},
			firstApproverStatus: "APPROVAL_PENDING",
			firstApprovedAt: null,
			firstApproverComment: "Under review.",
			secondApprover: {
				id: "APR010",
				name: "Liam Johnson"
			},
			secondApproverStatus: "DEFAULT",
			secondApprovedAt: null,
			secondApproverComment: "Awaiting first approval.",
			details: [
				{
					id: "DET006",
					type: "THIS_WEEK_ACTION_PLAN",
					content: "Follow up with key clients and finalize Q1 sales goals."
				},
				{
					id: "DET007",
					type: "LAST_WEEK_ACTION_REPORT",
					content: "Closed two major deals and improved team coordination."
				}
			]
		}
	]
};
